import React from "react";
import { Phone, MessageCircle, Bike, Bell } from "lucide-react";
import { useSettings } from "@/contexts/SettingsContext";
import {
    resolveWhatsAppDigits,
    resolveTelHref,
    whatsappUrl,
    bikeInquiryMessage,
} from "@/lib/contact";

/** Fixed bottom CTA strip on bike detail (mobile-first sales inquiries). */
const StickyInquiryBar = ({ bike, upcoming = false, onPrimary }) => {
    const { settings } = useSettings();
    const waDigits = resolveWhatsAppDigits(settings);
    const tel = resolveTelHref(settings);
    const waHref = whatsappUrl(waDigits, bikeInquiryMessage(bike, upcoming ? "pre_book" : "whatsapp_inquiry"));

    return (
        <div
            className="fixed inset-x-0 bottom-0 z-50 border-t border-[#e5e7eb] bg-white/95 backdrop-blur-md shadow-[0_-8px_30px_rgba(15,15,18,0.12)] pb-[env(safe-area-inset-bottom)]"
            data-testid="sticky-inquiry-bar"
        >
            <div className="container-x py-2 grid grid-cols-3 gap-1.5 sm:gap-2 max-w-3xl mx-auto">
                <a
                    href={tel}
                    className="flex flex-row items-center justify-center gap-1.5 rounded-xl border border-[#e5e7eb] bg-[#fafafa] active:border-[#ED1C24] active:text-[#ED1C24] py-3 px-2 text-xs font-heading font-semibold transition-colors min-h-[44px]"
                    data-testid="sticky-call"
                >
                    <Phone size={15} className="text-[#ED1C24] shrink-0" />
                    Call
                </a>
                <a
                    href={waHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex flex-row items-center justify-center gap-1.5 rounded-xl bg-[#25D366] active:bg-[#1ea952] text-white py-3 px-2 text-xs font-heading font-semibold transition-colors min-h-[44px]"
                    data-testid="sticky-whatsapp"
                >
                    <MessageCircle size={15} className="shrink-0" />
                    WhatsApp
                </a>
                <button
                    type="button"
                    onClick={onPrimary}
                    className="flex flex-row items-center justify-center gap-1.5 rounded-xl bg-[#ED1C24] active:bg-[#C0151B] text-white py-3 px-2 text-xs font-heading font-semibold transition-colors min-h-[44px]"
                    data-testid="sticky-primary-cta"
                >
                    {upcoming ? <Bell size={15} className="shrink-0" /> : <Bike size={15} className="shrink-0" />}
                    {upcoming ? "Register" : "Test ride"}
                </button>
            </div>
        </div>
    );
};

export default StickyInquiryBar;
